import { render, staticRenderFns } from "./ReminderGrid.vue?vue&type=template&id=4ae3f5c1"
import script from "./ReminderGrid.vue?vue&type=script&lang=js"
export * from "./ReminderGrid.vue?vue&type=script&lang=js"
import style0 from "./ReminderGrid.vue?vue&type=style&index=0&id=4ae3f5c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports